import { DEFAULT_FOLDERS_INBOX_AND_DOCS } from '../../constants';

export const isDefaultFolder = (folderId) => {
  const defFolder = DEFAULT_FOLDERS_INBOX_AND_DOCS[folderId];

  return !!defFolder;
};
